// This is intended to create a standard that we can use so to avoid problems moving forward. I expect we will update this as time goes on.

export default {
  background: 1,
  watermark: 2,
  header: 3,
  container: 3,
  card: 4,
  drawer: 5,
  fab: 5,
  modal: 6,
  loaderBackground: 9997,
  loaderSpinner: 9998,
  notification: 9999
};

// ###### Thu Oct 22 10:18:50 PDT 2020 for reference
export const existing = {
  // background: 1,
  // watermark: 2,
  // header: 3,
  // drawer: 4,
  // modal: 5,
  loaderBackground: 9997,
  loaderSpinner: 9998,
  notification: 9999
};